module.exports = __webpack_public_path__ + "img/tree.d8ce677a.jpeg";